import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { HttpErrorResponse } from '@angular/common/http';

import { AccountValidationResult } from '../../models/account';

@Component({
  selector: 'app-verify-email-page',
  templateUrl: './verify-email-page.component.html',
  styleUrls: ['./verify-email-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerifyEmailPageComponent {
  @Input() verifyEmailWorking: boolean;
  @Input() verifyEmailSuccess: boolean;
  @Input() accountValidationResult: AccountValidationResult;
  @Input() verifyEmailError: Error;

  constructor() { }

  public get hasError(): boolean {
    return !!this.verifyEmailError
  }

  public get errorMessage(): string {
    if (this.verifyEmailError instanceof HttpErrorResponse) {
      return this.verifyEmailError.error.message;
    } else {
      return this.verifyEmailError.message;
    }
  }

  public get accountValidationNeeded(): boolean {
    return this.accountValidationResult.validated === false;
  }
}
